export default "__VITE_ASSET__230b5eaf__"